var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settings)?_c('div',{staticClass:"settings"},[_c('span',[_vm._v(_vm._s(_vm.$i18n.t('presentations.presentations_form_name'))+":\n"+_vm._s(_vm.settings.presentation.name))]),_c('br'),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }